











































































































import { Component, Vue } from 'vue-property-decorator'
import { CvValue, ElementType } from '@/models'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { CV_VALUE_ELEMENT_TYPE_CATEGORIES, CV_VALUE_SMA_TYPES, CV_VALUE_COUNTRY } from '@/utils/constants'
import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'

@Component({
  name: 'Template',
  components: {
    UpsertElementTypeModal: () => import('@/components/modals/UpsertElementTypeModal.vue')
  }
})
export default class ElementTypeView extends Vue {
  private CV_VALUE_SMA_TYPES = CV_VALUE_SMA_TYPES
  private CV_VALUE_ELEMENT_TYPE_CATEGORIES = CV_VALUE_ELEMENT_TYPE_CATEGORIES
  private CV_VALUE_COUNTRY = CV_VALUE_COUNTRY

  private countries: CvValue[] = []
  private elementTypeCategories: CvValue[] = []
  private smaTypes: CvValue[] = []
  private elementTypeEdit: ElementType = { codeId: '', name: '', codeTemplate: '', allowAssets: false, allowSiblings: false }

  private filterElementTypes = ''
  private filterCategory = ''
  private filterSmaType = ''
  private filterCountry = ''

  private fields = [
    { key: 'name', label: `${this.$t('element_type_view.table.name')}` },
    { key: 'codeId', label: `${this.$t('element_type_view.table.code_id')}` },
    { key: 'codeTemplate', label: `${this.$t('element_type_view.table.code_template')}` },
    { key: 'autoGenerateCode', label: `${this.$t('element_type_view.table.auto_generate_code')}` },
    { key: 'smaType', label: `${this.$t('element_type_view.table.sma_type')}` },
    { key: 'category', label: `${this.$t('element_type_view.table.category')}` },
    { key: 'country', label: `${this.$t('element_type_view.table.country')}` },
    { key: 'action', label: `${this.$t('table.actions')}` }
  ]

  get elementTypesComputed(): ElementType[] {
    let filters: ElementType[] = this.elementTypes
    if (this.filterCountry != null && this.filterCountry !== '') {
      filters = filters.filter((item: ElementType) => this.filterCountry === item.country)
    }

    if (this.filterCategory != null && this.filterCategory !== '') {
      filters = filters.filter((item: ElementType) => this.filterCategory === item.category)
    }

    if (this.filterSmaType != null && this.filterSmaType !== '') {
      filters = filters.filter((item: ElementType) => this.filterSmaType === item.smaType)
    }

    if (this.filterElementTypes != null && this.filterElementTypes !== '') {
      filters = filters.filter((item: ElementType) => item.name.toLowerCase().includes(this.filterElementTypes.toLocaleLowerCase()))
    }

    return filters
  }

  get elementTypes(): ElementType[] {
    return this.$store.state.elementTypes
  }

  created() {
    this.loadElementTypes()
    this.loadElementTypeCategories()
    this.loadSmaTypes()
    this.loadCountries()
  }

  private async loadElementTypes() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    await this.$store.dispatch(ActionTypes.LOAD_ELEMENT_TYPES)
    this.$store.commit(MutationTypes.SET_LOADING, false)
  }

  private async loadElementTypeCategories() {
    this.elementTypeCategories = await CvValueUtils.getCvValuesByType(CV_VALUE_ELEMENT_TYPE_CATEGORIES)
  }

  private async loadSmaTypes() {
    this.smaTypes = await CvValueUtils.getCvValuesByType(CV_VALUE_SMA_TYPES)
  }

  private async loadCountries() {
    this.countries = await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY)
  }

  private editElementType(elementType: ElementType) {
    this.elementTypeEdit = Object.assign({}, elementType)
    this.$bvModal.show('upsertElementTypeModal')
  }

  private newElementType() {
    this.elementTypeEdit = Object.assign({}, this.elementTypeEdit, { codeId: '', name: '', codeTemplate: '', allowAssets: false, allowSiblings: false })
    this.$bvModal.show('upsertElementTypeModal')
  }

  private getCvValueName(codeId: string, type: string) {
    const typeName = CvValueUtils.getCvValueName(codeId, type)
    if (typeName === codeId) {
      return codeId
    }
    return typeName
  }

  private resetFilters() {
    this.filterCountry = ''
    this.filterElementTypes = ''
    this.filterCategory = ''
    this.filterSmaType = ''
  }
}
